import React from "react";
import { useTheme } from "styled-components";

const Countdown = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.849 13.82 9.814 9l5.035-4.82.009-.01a1.125 1.125 0 0 0-.796-1.92H3.938a1.125 1.125 0 0 0-.795 1.92l.008.01L8.186 9l-5.035 4.82-.008.01a1.125 1.125 0 0 0 .795 1.92h10.125a1.125 1.125 0 0 0 .786-1.93M6.876 6.189h4.248L9 8.22zm7.187-2.813-1.764 1.688H5.701L3.938 3.375zM3.938 14.625l4.5-4.307v1.495a.562.562 0 1 0 1.124 0v-1.495l4.5 4.307z"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default Countdown;
